import styles from "./Home.module.scss";
import HashflowSVG from "../assets/header/hashflow.svg";
import TwitterXSVG from "../assets/header/twitter-x.svg";
import TelegramSVG from "../assets/header/telegram.svg";
import DiscordSVG from "../assets/header/discord.svg";

export const Home = () => {
  return (
    <div className={`page ${styles.background}`}>
      <header>
        <img src={HashflowSVG} className={styles.logo} alt="logo" />
        <div className={styles.links}>
          <a
            href="https://docs.hashflow.com/hashflow"
            target="_blank"
            rel="noreferrer"
          >
            <h6>Docs</h6>
          </a>
          <a href="https://app.hashflow.com/" target="_blank" rel="noreferrer">
            <h6>Trade</h6>
          </a>
          <a
            href="https://app.hashflow.com/stake"
            target="_blank"
            rel="noreferrer"
          >
            <h6>Stake</h6>
          </a>
        </div>
        <div className={styles.socials}>
          <a
            href="https://x.com/hashflow"
            target="_blank"
            rel="noreferrer"
            role="button"
          >
            <img src={TwitterXSVG} alt="X" />
          </a>
          <a
            href="https://t.me/hashflowdex"
            target="_blank"
            rel="noreferrer"
            role="button"
          >
            <img src={TelegramSVG} alt="Telegram" />
          </a>
          <a
            href="https://discord.com/invite/eU35SNNdPC"
            target="_blank"
            rel="noreferrer"
            role="button"
          >
            <img src={DiscordSVG} alt="Discord" />
          </a>
        </div>
      </header>
      <div className={styles.landing}>
        <div className={styles.title}>
          <h1 className="gradient bold">The Liquidity Layer for DeFi</h1>
          <p>
            Tap into the largest RFQ network in crypto—tight spreads, zero
            slippage, and top-tier market makers at your fingertips.
          </p>
          <a
            href="https://docs.hashflow.com/hashflow"
            target="_blank"
            rel="noreferrer"
            role="button"
            className="button"
          >
            Integrate Now
          </a>
        </div>
        <div className={styles.stats}>
          <div>
            <h2>$25 billion+</h2>
            <p>in RFQ volume</p>
          </div>
          <div>
            <h2>30+</h2>
            <p>integrations</p>
          </div>
          <div>
            <h2>$500M+</h2>
            <p>in liquidity</p>
          </div>
        </div>
      </div>
    </div>
  );
};
